export const deleteKegMutation = /* GraphQL */ `mutation deleteKeg ($input: deleteKeg!) {
    deleteKeg(input: $input) {
      id
    }
  }`
